export default [
  {
    path: '/account/history',
    name: 'order-history',
    component: () => import('@modules/account/order-history.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/history/:id',
    name: 'order-history-id',
    component: () => import('@modules/account/order-history-id.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/credits',
    name: 'account-credits',
    component: () => import('@modules/account/credits.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/details',
    name: 'account-details',
    component: () => import('@modules/account/details/index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/subaccounts',
    name: 'account-subaccounts',
    component: () => import('@modules/account/subaccounts/index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/login',
    name: 'account-login',
    component: () => import('@modules/account/login.vue'),
  },
  {
    path: '/account/forgot-password',
    name: 'forgot-password',
    component: () => import('@modules/account/forgot-password.vue'),
  },
  {
    path: '/account/reset-password/:token',
    name: 'reset-password',
    component: () => import('@modules/account/reset-password.vue'),
  },
  {
    path: '/account/newsrooms',
    name: 'account-newsrooms',
    component: () => import('@modules/account/newsrooms/index.vue'),
  },
  {
    path: '/account/newsrooms/:id/press-releases',
    name: 'account-newsrooms-id-press-releases',
    component: () => import('@modules/account/newsrooms/press-releases.vue'),
  },
]
